import { render, staticRenderFns } from "./WorkFlowListCard.vue?vue&type=template&id=68e0453b&scoped=true"
import script from "./WorkFlowListCard.vue?vue&type=script&lang=js"
export * from "./WorkFlowListCard.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowListCard.vue?vue&type=style&index=0&id=68e0453b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0453b",
  null
  
)

export default component.exports